const BillSumaryConfig = [
    { span: 5, height: "27px", classes: "marginTop-56" },
    { span: 8, height: "145px", classes: "marginTop-8" },
]

export default BillSumaryConfig
